import { criarParticipante } from '@/uteis/action/tramite/participante'

export const criarSetor = (dadosSessao) => {
  var setor = criarParticipante(dadosSessao.descricaoDepartamento, dadosSessao.idDepartamento, 'ID', dadosSessao.siglaDepartamento)
  var orgao = criarParticipante(dadosSessao.descricaoOrgao, dadosSessao.idOrgao, 'ID', dadosSessao.siglaOrgao)

  setor.participantePai = orgao

  return setor
}
